import React from "react";
import { Link } from "react-router-dom";
import { useSEO } from "../lib/seo";

const RELATED = [["/terms-and-conditions","Terms & Conditions"],["/privacy-policy","Privacy Policy"],["/return-refund-policy","Return & Refund Policy"],["/cancellation-policy","Cancellation Policy"]];

export default function ShippingPolicy() {
  useSEO({
    title: "Shipping Policy — PrintMyTees",
    description: "Read the PrintMyTees Shipping Policy covering order processing, shipping charges, delivery timelines, address requirements and courier issues.",
  });

  return (
    <main className="container-pmt py-10 sm:py-16 max-w-4xl">
      <div className="overline text-[#E34F26]">PrintMyTees</div>
      <h1 className="mt-3 font-black text-3xl sm:text-4xl md:text-5xl uppercase">Shipping Policy</h1>
      <p className="mt-3 text-sm text-stone-600">Last updated: October 2026</p>
      <div className="mt-8 sm:mt-10 space-y-8 sm:space-y-10 text-stone-700 leading-7">
        <section>
          <h2 className="text-xl sm:text-2xl font-bold text-stone-900">1. Order Processing</h2>
          <p className="mt-2">Orders are processed after successful payment confirmation. Customised products may require additional production time depending on the order requirements.</p>
        </section>

        <section>
          <h2 className="text-xl sm:text-2xl font-bold text-stone-900">2. Shipping Charges</h2>
          <p className="mt-2">Applicable delivery or shipping charges are shown during the order process or otherwise communicated for the order.</p>
        </section>

        <section>
          <h2 className="text-xl sm:text-2xl font-bold text-stone-900">3. Delivery Time</h2>
          <p className="mt-2">Delivery time depends on the product, customization, quantity, delivery location, and courier service. Available delivery information will be provided for the order when applicable.</p>
        </section>

        <section>
          <h2 className="text-xl sm:text-2xl font-bold text-stone-900">4. Delivery Address</h2>
          <p className="mt-2">Customers are responsible for providing a complete and accurate delivery address, mobile number, city, district, state, and pincode.</p>
        </section>

        <section>
          <h2 className="text-xl sm:text-2xl font-bold text-stone-900">5. Courier Delays</h2>
          <p className="mt-2">Delivery may be delayed due to courier operations, weather, holidays, incorrect address information, or circumstances beyond our reasonable control.</p>
        </section>

        <section>
          <h2 className="text-xl sm:text-2xl font-bold text-stone-900">6. Damaged or Missing Package</h2>
          <p className="mt-2">If a package arrives damaged or appears to be missing, customers should contact PrintMyTees as soon as possible with the order number and relevant details.</p>
        </section>
      </div>
      <div className="mt-10 sm:mt-12 border border-[#E6DFD5] bg-[#F3EDE2] p-5 sm:p-6">
        <div className="overline">Related Policies</div>
        <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-3">
          {RELATED.map(([to,label]) => (
            <Link key={to} to={to} className="btn-outline-pmt text-center focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#D95328] focus-visible:ring-offset-2">{label}</Link>
          ))}
        </div>
      </div>
      <Link to="/" className="inline-block mt-8 sm:mt-10 btn-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#D95328] focus-visible:ring-offset-2">Back to Home</Link>
    </main>
  );
}
